const redirects = {
   'url1' : { 
      landing_page : 'https://minstoradag.org/stod-oss/for-foretag/julkompis/?utm_source=reaktion&utm_medium=email&utm_campaign=jul24-foretag-mejl1&utm_content=', 
      name: "jul24-toppbild" 
   },

   'url2' : { 
      landing_page : 'https://minstoradag.org/stod-oss/for-foretag/julkompis/?utm_source=reaktion&utm_medium=email&utm_campaign=jul24-foretag-mejl1&utm_content=', 
      name: "jul24-knapp-Vi-vill-bli-julkompis" 
   },

   'url3' : { 
      landing_page : 'https://minstoradag.org/stod-oss/for-foretag/julkompis/?utm_source=reaktion&utm_medium=email&utm_campaign=jul24-foretag-mejl1&utm_content=', 
      name: "jul24-knapp-bli-julkompis" 
   },

   'url4' : { 
      landing_page : 'https://minstoradag.org/stod-oss/for-foretag/julkompis/sa-har-kan-ni-anvanda-materialet-for-julkompispaketen/?utm_source=reaktion&utm_medium=email&utm_campaign=jul24-foretag-mejl1-material&utm_content=', 
      name: "jul24-vara-paket" 
   },

   'url5' : { 
      landing_page : 'https://minstoradag.org/stod-oss/for-foretag/julkompis/?utm_source=reaktion&utm_medium=email&utm_campaign=jul24-foretag-mejl1&utm_content=', 
      name: "jul24-paket-snall" 
   },

   'url6' : { 
      landing_page : 'https://minstoradag.org/stod-oss/for-foretag/julkompis/?utm_source=reaktion&utm_medium=email&utm_campaign=jul24-foretag-mejl1&utm_content=', 
      name: "jul24-paket-snallare" 
   },

   'url7' : { 
      landing_page : 'https://minstoradag.org/stod-oss/for-foretag/julkompis/?utm_source=reaktion&utm_medium=email&utm_campaign=jul24-foretag-mejl1&utm_content=', 
      name: "jul24-paket-snallast" 
   },

   'url8' : { 
      landing_page : 'https://minstoradag.org/stod-oss/for-foretag/julkompis/?utm_source=reaktion&utm_medium=email&utm_campaign=jul24-foretag-mejl1&utm_content=', 
      name: "jul24-paket-pil-snall" 
   },


   'url9' : { 
      landing_page : 'https://minstoradag.org/stod-oss/for-foretag/julkompis/?utm_source=reaktion&utm_medium=email&utm_campaign=jul24-foretag-mejl1&utm_content=', 
      name: "jul24-paket-pil-snallare" 
   },


   'url10' : { 
      landing_page : 'https://minstoradag.org/stod-oss/for-foretag/julkompis/?utm_source=reaktion&utm_medium=email&utm_campaign=jul24-foretag-mejl1&utm_content=', 
      name: "jul24-paket-pil-snallast" 
   },

   'url11' : { 
      landing_page : 'https://minstoradag.org/stod-oss/for-foretag/julkompis/?utm_source=reaktion&utm_medium=email&utm_campaign=jul24-foretag-mejl1&utm_content=', 
      name: "jul24-knapp-var-snall-och-klicka-har"
   },


   'url12' : { 
      landing_page : 'https://minstoradag.org/stod-oss/for-foretag/julkompis/?utm_source=reaktion&utm_medium=email&utm_campaign=jul24-foretag-mejl1&utm_content=', 
      name: "jul24-knapp-logo"
   },

   'url13' : { 
      landing_page : 'https://www.facebook.com/minstoradag', 
      name: "jul24-fb"
   },

   'url14' : { 
      landing_page : 'https://www.instagram.com/minstoradag', 
      name: "jul24-ig"
   },

   'url15' : { 
      landing_page : 'https://www.linkedin.com/company/min-stora-dag', 
      name: "jul24-linkedin"
   },
   
   'url16' : { 
      landing_page : 'https://twitter.com/minstoradag', 
      name: "jul24-twitter"
   },

   'url17' : { landing_page : 'https://minstoradag.org/stod-oss/for-foretag/julkompis/?utm_source=reaktion&utm_medium=email&utm_campaign=jul24-foretag-mejl2&utm_content=', name: "jul24-mejl-2" },


   
};

export default redirects